import axios from 'axios';
import { API_ROUTES } from '@/config/api-routes';
import { normalizeGreetingFileMetadata, } from '@/shared/model/greeting-file.model';
/** CRM file category for per-agent call greeting audio (`POST /api/files/upload?category=…`). */
export const GREETING_FILE_CATEGORY = 'grading';
function greetingQueryParams(uploadedBy) {
    return new URLSearchParams({
        category: GREETING_FILE_CATEGORY,
        uploadedBy: uploadedBy.trim(),
    });
}
export function buildGreetingDownloadPath(uploadedBy) {
    const params = greetingQueryParams(uploadedBy);
    return `${API_ROUTES.fileDownloadByCategory}?${params.toString()}`;
}
/** `GET /api/files/by?category=grading&uploadedBy={email}` — null when no greeting exists. */
export async function fetchGreetingMetadata(uploadedBy) {
    const email = uploadedBy.trim();
    if (!email) {
        return null;
    }
    try {
        const { data } = await axios.get(`${API_ROUTES.fileMetadataByCategory}?${greetingQueryParams(email).toString()}`);
        return normalizeGreetingFileMetadata(data);
    }
    catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 404) {
            return null;
        }
        throw error;
    }
}
export async function uploadGreetingFile(file) {
    const formData = new FormData();
    formData.append('file', file);
    const { data } = await axios.post(`${API_ROUTES.fileUpload}?category=${GREETING_FILE_CATEGORY}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    const metadata = normalizeGreetingFileMetadata(data);
    if (!metadata) {
        throw new Error('Upload succeeded but the server did not return greeting file metadata.');
    }
    return metadata;
}
export async function deleteGreetingFile(fileId) {
    await axios.delete(`${API_ROUTES.files}/${fileId}`);
}
export async function downloadGreetingBlob(uploadedBy) {
    const email = uploadedBy.trim();
    if (!email) {
        return null;
    }
    try {
        const { data } = await axios.get(buildGreetingDownloadPath(email), {
            responseType: 'blob',
        });
        if (!(data instanceof Blob) || data.size === 0) {
            return null;
        }
        return data;
    }
    catch {
        return null;
    }
}
